exports.components = {
  "component---src-templates-error-page-tsx": () => import("./../../../src/templates/ErrorPage.tsx" /* webpackChunkName: "component---src-templates-error-page-tsx" */)
}

